import React from 'react';
import classnames from 'classnames';
import s from './FeedLayout.scss';

export interface Props {
  className?: string;
}

const FeedLayout: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => (
  <div className={classnames(s['root'], className)}>
    <div className={s['feed-wrapper']}>{children}</div>
  </div>
);
FeedLayout.displayName = 'FeedLayout';

export default FeedLayout;
